export const CONSULTATION_SECTION_ID = 'book-consultation'
export const INSTAGRAM_URL = 'https://www.instagram.com/mygreenheaven.in/'
